import React from 'react';

import { IAction } from '../../ActionsMenu/types';
import ActionsMenuCircledButton from '../../shared/ActionsMenuCircledButton';
import s from './index.module.css';

interface IProps {
  actions: IAction[];
}

function SwitchToChronoMode({ actions }: IProps) {
  return (
    <ActionsMenuCircledButton
      actions={actions}
      actionsMenuClassName={s.switchMenu}
      iconClassName={s.rotate}
      optionsClassName={s.option}
    />
  );
}

export default SwitchToChronoMode;
